import React, {useContext, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import clsx from 'clsx';

import {TREND_THEMES} from '../../../constants/trend-themes';
import {FIFA_TEAM_MEMBERS} from '../constants/fifa2022/team-members';
import {Theme} from '../contexts/theme';
import {fetchData, getCountryIconUrl} from '../utils/helpers';

import Loader from './loader';

import styles from './modal-team-content.module.css';

const ModalTeamContent = ({
  teamId,
  countryCode,
  teamName
}) => {
  const [data, setData] = useState({teamMembers: [], isLoading: true});
  const theme = useContext(Theme);
  const {t} = useTranslation();

  useEffect(async() => {
    if (theme === TREND_THEMES.FIFA) {
      return setData({teamMembers: FIFA_TEAM_MEMBERS[teamId], isLoading: false});
    }

    if (theme === TREND_THEMES.IHHF) {
      return setData({teamMembers: [], isLoading: false});
    }

    try {
      setData({...data, isLoading: true});

      const teamMembers = await fetchData({
        url: `football/worldcup-2022/teams/${teamId}/members`
      });

      setData({
        teamMembers,
        isLoading: false
      });
    } catch (e) {
      setData({...data, isLoading: false});
      console.error(`${theme} members loading error`);
    }
  }, [teamId, theme]);

  if (data.isLoading) {
    return <Loader color='#fff' />;
  }

  return (
    <>
      <div className={styles.head}>
        <img
          className={styles.icon}
          src={getCountryIconUrl(countryCode)}
          alt={`Флаг ${teamName}`}
          width={34}
          height={24}
        />
        <span className={styles.countryName}>{teamName}</span>
      </div>
      <div className={styles.modalTeamTable}>
        {data.teamMembers.length > 0 && (
          <div className={styles.modalTeamTableHead}>
            <div
              className={clsx(
                styles.modalTeamTableHeadItem,
                styles.modalTeamTableHeadItemLeft
              )}
            >
              {t('fifa2022.teamModal.number')}
            </div>
            <div className={styles.modalTeamTableHeadItem}>
              {t('fifa2022.teamModal.name')}
            </div>
          </div>
        )}
        <div>
          {data.teamMembers.map(teamMember => (
            <div key={teamMember.number} className={styles.modalTeamTableBodyItem}>
              <div className={styles.modalTeamTableBodyItemNumber}>{teamMember.number || '-'}</div>
              <div className={styles.modalTeamTableBodyItemName}>{teamMember.name}</div>
            </div>
          ))}
        </div>
      </div>
    </>);
};

export default ModalTeamContent;
